import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sent',
  templateUrl: './icon-sent.component.html',
  styleUrls: ['./icon-sent.component.scss']
})
export class IconSentComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
